// @flow
import styled, { css } from "styled-components";
const deployTarget = process.env.REACT_APP_DEPLOY_TARGET;

const Button = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  vertical-align: middle;
  min-height: 47px;
  margin-left: 10px;
  padding: 0 17px;
  font-weight: 700;
  font-size: 18px;
  color: ${props => props.theme.mainDark};
  border-radius: 8px;
  border: none;
  cursor: pointer;

  ${({ type, disabled }) => {
    if (deployTarget === "irontrade" && type === "refill") {
      if (disabled === true) {
        return css`
          color: #99959d;
          border: 2px solid #99959d;
          cursor: auto;
          pointer-events: none;
        `;
      }

      return css`
        background: none;
        border: 2px solid #ffffff;
        box-shadow: none;
        text-shadow: none;
        color: #ffffff;
        transition: 0.3s all;

        :hover,
        :focus,
        :active {
          color: #1b546a;
          background: #ffffff;
          box-shadow: none;
          text-shadow: none;
        }
      `;
    }

    if (disabled === true) {
      return css`
        border-bottom: 2px solid #7a7c8a;
        box-shadow: inset 0px -1px 0px 0px #bcbfce;
        background-color: #a5a7b4;
        background: linear-gradient(to top, #a5a7b4, #bdc0cf);
        cursor: default;
        pointer-events: none;

        ${({ theme }) =>
          theme.isIntlProjectLight &&
          css`
            color: #99959d;
            background: none;
            border: 2px solid #99959d;
            box-shadow: none;
            text-shadow: none;
          `};
      `;
    }

    if (type === "deposit") {
      return css`
        color: #fff;
        text-shadow: -1px -1px #56a008;
        border-bottom: 2px solid ${props => props.theme.upperBorder};
        box-shadow: inset 0px -1px 0px 0px ${props => props.theme.upperBoxShadow};
        background-color: ${props => props.theme.upper};
        background: linear-gradient(
          to top,
          ${props => props.theme.upper},
          ${props => props.theme.upperAccent}
        );

        ${deployTarget === "siamoption" &&
          css`
            box-shadow: inset 0px -1px 0px 0px ${props => props.theme.upperBoxShadow};
          `};

        :hover,
        :focus,
        :active {
          background-color: ${props => props.theme.upperAccent};
          background: linear-gradient(
            to top,
            ${props => props.theme.upperAccent},
            ${props => props.theme.upper}
          );

          ${deployTarget === "siamoption" &&
            css`
              box-shadow: inset 0px -1px 0px 0px rgba(99, 191, 0, 1);
            `};
        }
        ${({ theme }) =>
          theme.isIntlProjectLight &&
          css`
            background: none;
            border: 2px solid #ffffff;
            box-shadow: none;
            text-shadow: none;

            :hover,
            :focus,
            :active {
              color: #1b546a;
              background: #ffffff;
              box-shadow: none;
              text-shadow: none;
            }
          `};
      `;
    }

    return css`
      border-bottom: 2px solid #ca7700;
      box-shadow: inset 0px -1px 0px 0px #ca7700;
      background-color: #ca7700;
      background: linear-gradient(to top, #fd9600, #ca7700);

      :hover,
      :focus,
      :active {
        background-color: #ca7700;
        background: linear-gradient(to top, #ca7700, #fd9600);
      }

      ${({ theme }) =>
        theme.isIntlProjectLight &&
        css`
          background: none;
          border: 2px solid #ffffff;
          box-shadow: none;
          text-shadow: none;

          :hover,
          :focus,
          :active {
            color: #1b546a;
            background: #ffffff;
            box-shadow: none;
            text-shadow: none;
          }
        `};
    `;
  }};

  @media (max-width: 959px) {
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;
    align-self: center;
    min-width: 0;
    min-height: 30px;
    font-size: 16px;
    border-radius: 4px;
  }

  @media (max-width: 479px) {
    min-width: 40px;
    padding: 0 7px;
    color: #fff;
  }

  @media (max-width: 425px) {
    min-width: 34px;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/TradeHeader/Button.js